import React from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import SideBar from "../SideBar";
import TopBar from "../TopBar";

function Master() {
  const { i18n } = useTranslation(); // Access i18n instance to control language

  const toggleLanguage = () => {
    // Toggle between languages
    const newLang = i18n.language === "en" ? "he" : "en";
    i18n.changeLanguage(newLang);
  };
  return (
    <>
      <SideBar />
      <TopBar toggleLanguage={toggleLanguage} />

      <div className="content">
        <Outlet />
      </div>
    </>
  );
}

export default Master;
